
import type { CartItem } from "@/context/CartContext";
import { supabase } from "@/integrations/supabase/client";

interface CustomerProfile {
  first_name: string;
  last_name: string;
  phone: string;
  address: string;
  company: string | null;
}

interface OrderDetails {
  subtotal: number;
  tps: number;
  tvq: number;
  total: number;
  orderId: string;
  orderNumber: number;
}

interface SendOrderEmailParams {
  customerEmail: string;
  customerProfile: CustomerProfile;
  products: CartItem[];
  orderDetails: OrderDetails;
}

export const sendOrderEmail = async ({
  customerEmail,
  customerProfile,
  products,
  orderDetails,
}: SendOrderEmailParams): Promise<void> => {
  console.log("Sending order confirmation email", {
    to: customerEmail,
    products,
    orderDetails
  });
  
  const { error } = await supabase.functions.invoke("send-order-confirmation", {
    body: {
      customerEmail,
      customerProfile,
      products,
      orderDetails,
    },
  });

  if (error) {
    console.error("Failed to send order confirmation email:", error);
    throw error;
  }
  
  console.log("Order confirmation email sent successfully");
};
